<div class="modal-header m-transparent">
  <button type="button" class="close mr-1" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <h1 class="app-title-midi">כדי שנוכל לשלוח לך הצעה, נא לקרוא ולאשר את תנאי השימוש</h1>
  <div class="app-font-regular m-terms-use-text m-term-border">
    <p>אנו מאשרים, כי כל הפרטים שנמסרו על ידינו בבקשה זו נכונים ומלאים.</p>
    <ul>
      <li>ידוע לנו, כי ביצוע ההלוואה מותנה באישור הגורמים המוסמכים בבנק ובמילוי כל התנאים והדרישות לביצוע ההלוואה,
        כמפורט במדריך לקבלת הלוואה המצוי באתר הבנק ותשלום כל ההוצאות והעמלות הנדרשות. ידוע לנו כי כל אישור להלוואה שינתן
        על בסיס הפרטים שנמסרו על ידינו, הינו בגדר הבעת נכונות עקרונית בלבד מצד הבנק להעמיד את ההלוואה, והוא מותנה, בין
        היתר, באימות כל הנתונים שנמסרו על ידינו. אישור כאמור אינו מטיל על הבנק התחייבות או אחריות כלשהן, ורק האמור בהסכם
        ההלוואה החתום בידי הבנק מחייב את הבנק.</li>
      <li>סכום הזכאות ותנאי הזכאות המחייבים את הבנק, ייקבעו בפועל בהתאם לתעודת זכאות תקפה כפי שתונפק, אם תונפק, על ידי
        משרד הבינוי והשיכון. מתן ההלוואה כפוף לאישור הבנק. </li>
      <li>ידוע לנו שהבנק רשאי, בין היתר, לשנות את שיעור הריבית ו/או שיעור התוספת/ההפחתה לבסיס הריבית ו/או תנאים אחרים
        שיאושרו לאחר חלוף מועד שמירת הריבית. מועד שמירת הריבית ימסר לכם עם ההודעה על אישור ההלוואה, ככל שתאושר.</li>
      <li>בכל מקרה, כל אישור כאמור, תקף למשך 45 יום ממועד האישור או תקופה קצרה יותר שתקבע באישור, ולא יהיה לו תוקף לאחר
        מכן.</li>
      <li>אנו מתחייבים להודיע לבנק על כל שינוי בפרטים שמסרנו.</li>
      <li>אנו מסכימים כי אם יגיע לידי הבנק מידע בנוגע לשינוי הפרטים שנמסרו על ידינו בבקשת ההלוואה, או מידע אחר המעלה חשש
        בדבר יכולתנו לעמוד בהתחייבויותינו על פי הסכם ההלוואה, הבנק יהיה רשאי שלא לתת את ההלוואה, כולה או חלקה, או את
        יתרת ההלוואה, אם ההלוואה מבוצעת בחלקים.</li>
      <li>ידוע לנו שבקשות שיוגשו לאחר השעה 16:00, או בימי שישי או בערב חג, ייענו ביום העסקים הבא.</li>
    </ul>
    <p><strong>הודעה בנוגע לקבלת חיווי אשראי</strong></p>
    <p>בהמשך לבקשת האשראי שלך, הבנק יפנה לקבלת
      חיווי אשראי מלשכת האשראי, שתבקש מבנק ישראל נתוני אשראי לגביך, הכלולים במאגר.</p>
    <p><strong>"إشعار بطلب الحصول على سجلّ الائتمان</strong></p>
    <p>إشعار بطلب للحصول على سجلّ الائتمان: بعد تقديمك طلب للحصول على الائتمان سوف يتقدم البنك بطلب للحصول على
      بيان ائتمان من مكتب الائتمان، الذي سيطلب بدوره الحصول من بنك إسرائيل على بياناتك الائتمانية المدرجة في قاعدة
      البيانات.</p>
    <p><strong>ויתור על סודיות בנקאית והגנת הפרטיות</strong></p>
    <p>לצורך אישור ההלוואה וקבלת ההלוואה, הנכם נדרשים להמציא לבנק פרטים שונים, הנוגעים לכם, למצבכם הכלכלי והאישי ולנכס
      המוצע כבטוחה לבנק ולנכסים אחרים שברשותכם, כמפורט בבקשה וביתר מסמכי הבנק והמסמכים שידרשו על ידי הבנק לצורך ביצוע
      ההלוואה. פרטים אלה נדרשים לבנק הן לצורך בחינת הבקשה להלוואה, ביצועה וניהולה והן מאחר שהבנק מחוייב לפי דין לשמור
      מידע ולהעבירו לרשויות שונות, בהתאם לדרישות חוקיות ורגולטוריות, כפי שיהיו מעת לעת. ללא הסכמתכם למסירת פרטים אלה, לא
      יוכל הבנק לבחון את בקשתכם ולבצע את ההלוואה, אם וככל שתאושר ההלוואה ויומצאו לבנק כל המסמכים והבטוחות הנדרשים על
      ידו. לכן, לצורך המשך הטיפול בבקשתכם, נדרש אישורכם כמפורט להלן.</p>
    <p></p>
    <p><strong>אישור המבקשים בדבר ויתור על סודיות בנקאית והגנת הפרטיות:</strong></p>
    <p>בהמשך לבקשתנו שלעיל (להלן-"הבקשה") ולהצהרות הכלולות בה הרינו לאשר:</p>
    <ol>
      <li>אנו מייפים את כוחכם לבדוק מידע ברישומים הקיימים בבנק, בכפוף לכל דין, וכן לקבל מכל מקור שהוא, לרבות מרשם
        אוכלוסין,חברה בנק או מעביד, כל מידע מכל מקור שהוא אשר דרוש לדיון בבקשה ו/או לצורך אימות הפרטים המפורטים בה, והכל
        בכפוף לדין. ידוע לנו שהבנק אינו יכול לאמת את הנתונים הנמסרים על ידי מקורות אלה. </li>
      <li>הסכמתי שלעיל ניתנת בכפוף לכך שאהיה זכאי להודיע לכם בכל עת על ביטולה. אולם ידוע לי, כי לא אהיה זכאי לבטל הסכמתי
        זו בטרם פרעתי את כל האשראי שלי אצלכם.</li>
      <li>במקרה בו הוצע על ידינו או נדרש על ידי הבנק צירוף ערבים או שעבוד נכסים להבטחת ההלוואה על ידי צדדים שלישים
        (ערבים ומשעבדים כאמור, יקראו להלן- "ערבים") להלוואה, יהיה הבנק רשאי להעביר את המידע שקיבל מכל המקורות הנ"ל גם
        לערבים.</li>
      <li>ידוע לנו שאין ביכולת הבנק לאמת את הנתונים המתקבלים מהמקורות הנ"ל, ואנו מוותרים על כל טענה ו/או תביעה כנגד הבנק
        בקשר לאי אימות הנתונים ו/או העברת המידע ו/או התוצאות הנובעות מהאמור לעיל.</li>
      <li>למען הסר ספק, הננו מסכימים לאמור לעיל, ומוותרים על זכויותינו לסודיות או לאחריות הבנק ביחס למידע המפורט לעיל,
        על פי כל הסכם, נוהג בנקאי ו/או דין לרבות חוק הגנת הפרטיות התשמ"א – 1980, ו/או כל חוק אחר, ובלבד שהשימוש במידע
        ושמירתו יעשו בכפוף לכל דין החל על נושא זה. </li>
    </ol>
    <div *ngIf="isAdvisor">
      <p><strong>אישור יועץ:</strong></p>
      <p>הריני לאשר כי:</p>
      <ol>
        <li>כל הפרטים שמלאתי בשם המבקשים נכונים, מלאים ומדוייקים. </li>
        <li>המבקשים יפו את כוחי להגיש בשמם את הבקשה, לרבות כל ההצהרות הכלולות בה, לנהל בשמם מו"מ עם הבנק על תנאי ההלוואה
          ולחתום בשמם על הבקשה, על אישורם לויתור על סודיות בנקאית והגנת הפרטיות, כמפורט לעיל, לקבל בשמם הודעות מהבנק,
          לרבות את האישור העקרוני להלוואה או הודעה על דחית הבקשה, לתת את הסכמתם לכך שהבנק יקבל דו"ח אשראי על פי חוק
          נתוני אשראי התשע"ו – 2016 לצורך בחינת הבקשה או לקבל בשמם הודעה על בקשת חיווי אשראי או בקשת דו"ח אשראי בהתאם
          לחוק זה וכן לטפל בכל ענין אחר הנדרש לצורך הטיפול בבקשתם.</li>
        <li>כמו כן, המבקשים הודיעו לי כי הינם מסכימים כי הודעות בנוגע לבקשתם ישלחו אליהם או אלי במייל(בהתכתבות לא
          מאובטחת) או בהודעות SMS, והינם מודעים לסיכונים הכרוכים בכך.</li>
      </ol>
    </div>
  </div>
  <!--CB-->
  <div class="row">
    <div class="col-12 mt-2">
      <input [formControl]="agree" type="checkbox" class="app-input" name="checkbox-2" id="checkbox-2">
      <label for="checkbox-2" class="check" tabindex="0" data-id="check-agree-mail">
        {{'SUMMARIZE.CBOX_Contidentiality'|translate}}
      </label>
    </div>
  </div>

  <!--BTN Submit-->
  <div class="text-center">
    <button class="responsive-button app-button button-primary-disabled m-terms-use-btn px-3 mt-2"
      (click)="save()">{{'TERMS_OF_USE.AGREE' | translate}}</button>
    <small class="m-error form-text" *ngIf="errorMessage">
      {{ errorMessage }}
    </small>
  </div>


// WEBPACK FOOTER //
// ./src/app/terms-of-use-final/terms-of-use-final.component.html